import React from 'react'
import Icon from '../../../../../atoms/Icon'
import ReportItemStatusBadge from '../../components/ReportItemStatusBadge'

export const getColumns = ({ statuses }) => ([
  {
    accessorKey: 'displayName',
    header: 'Display Name',
    size: 300
  },
  {
    accessorKey: 'codeName',
    header: 'Code'
  },
  {
    accessorKey: 'isCustom',
    header: 'Custom',
    cell: ({ getValue }) => (getValue() ? <Icon name='check' /> : ''),
    align: 'center',
    size: 50
  },
  {
    accessorKey: 'hidden',
    header: 'Hidden',
    cell: ({ getValue }) => (getValue() ? <Icon name='check' /> : ''),
    align: 'center',
    size: 50
  },
  {
    accessorKey: 'attachmentCount',
    header: 'Attachments',
    cell: ({ getValue }) => getValue() || '',
    align: 'center',
    size: 50
  },
  {
    accessorKey: 'threadKey',
    header: 'Comments',
    cell: ({ getValue }) => (getValue() ? <Icon name='check' /> : ''),
    align: 'center',
    size: 50
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 80,
    cell: ({ getValue }) => {
      const status = statuses?.find(({ statusId }) => statusId === getValue()) ?? {}
      return ReportItemStatusBadge({ ...status })
    }
  }
])
